import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import friend from './modules/friend'
import choice from './modules/choice'
Vue.use(Vuex)

// const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    user,
    friend,
    choice
  }
  // strict: debug
})



// WEBPACK FOOTER //
// ./src/store/index.js